import React,{useState} from "react";
import { submitFormData } from "../../lib/callBackApiConnet";
import './CallBack.css';

function CallBack() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_number: '',
    user_type: '',
    organization: '',
    interest: {
      impact_league: false,
      cause_marketing: false,
      non_profit_awareness: false,
      others: false
    },
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
        const updatedInterest = {};
    
        // Uncheck all other checkboxes
        Object.keys(formData.interest).forEach((key) => {
          updatedInterest[key] = false;
        });
    
        // Update the checked checkbox
        updatedInterest[name] = checked;
    
        setFormData({
          ...formData,
          interest: updatedInterest
        });
      } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const isValidName = (name) => {
    return name.length >= 2 && /.*[0-9].*/.test(name) === false;
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isValidPhoneNumber = (phone_number) => {
    return /^[0-9]{10}$/.test(phone_number);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Perform validation
    const validationErrors = {};
    if (!isValidName(formData.name)) {
      validationErrors.name = 'Please enter a valid name';
    }
    if (!isValidEmail(formData.email)) {
      validationErrors.email = 'Please enter a valid email id';
    }
    if (!isValidPhoneNumber(formData.phone_number)) {
      validationErrors.phone_number = 'Please enter a valid phone number';
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Filter the interest fields to include only the true values
  const selectedInterests = Object.keys(formData.interest).filter(
    (key) => formData.interest[key]
  );

  // Convert selected interests to a string
  const interestsString = selectedInterests.join(', ');

  try {
    await submitFormData( {...formData,
        interest: interestsString});
    setFormData({
        name: '',
        email: '',
        phone_number: '',
        user_type: '',
        organization: '',
        interest: {
            impact_league: false,
            cause_marketing: false,
            non_profit_awareness: false,
            others: false
        },
        message: ''
    });
    // alert( "Your message has been successfully delivered." );
    setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
    }, 10000); 
  } catch (error) {
    console.error("Error:", error.response.data);
    setErrors(error.response.data.errors);
  }
};

  return (
    <div className="form-container">
      <div className="formInfo">
      <div className="formHeading">Work with us!</div>
      <div>Interested in joining us?</div>
      <div className="businessDays">We will reach back to you within 1-3 business days.</div>
      </div>
      
        
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Your Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          {errors.name && <span className="error">{errors.name}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="phone_number">Phone Number</label>
          <input
            type="text"
            id="phone_number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
          />
          {errors.phone_number && <span className="error">{errors.phone_number}</span>}
        </div>

        <div className="organizationRow">
        <div className="form-group">
          <label htmlFor="user_type">I represent</label>
          <select
            id="user_type"
            name="user_type"
            value={formData.user_type}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="corporate">A corporate</option>
            <option value="ngo">An NGO</option>
            <option value="individual">An Individual</option>
          </select>
        </div>
        <div className="form-group nameOrganization">
          <label htmlFor="organization">Name of the organization</label>
          <input
           
            type="text"
            id="organization"
            name="organization"
            value={formData.organization}
            onChange={handleChange}
          />
        </div>
        </div>
        
        <div className="form-group">
          <label>I'm interested in</label>
          <div className="checkbox-group">
            <label>
              <input
                type="checkbox"
                name="impact_league"
                checked={formData.interest.impact_league}
                onChange={handleChange}
              />
              <div className="checkboxOption">Impact League</div>
            </label>
            <label>
              <input
                type="checkbox"
                name="cause_marketing"
                checked={formData.interest.cause_marketing}
                onChange={handleChange}
              />
              <div className="checkboxOption">Cause Marketing</div>
              
            </label>
            <label>
              <input
                type="checkbox"
                name="non_profit_awareness"
                checked={formData.interest.non_profit_awareness}
                onChange={handleChange}
              />
              <div className="checkboxOption">Non-Profit Awareness</div>
              
            </label>
            <label>
              <input
                type="checkbox"
                name="others"
                checked={formData.interest.others}
                onChange={handleChange}
              />
              <div className="checkboxOption">Other</div>
              
            </label>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="message">Anything else you want to tell us?</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>
        {success && (
          <div className="successMessage">
            Your message has been successfully delivered.
          </div>
        )}
        <button  className={success ? "callbackButtonSuccess" : "callbackButton"} type="submit">Submit</button>
      </form>
    </div>
  );
}

export default CallBack;
